import React, { Component, useEffect, useState } from "react";
import { IonContent, IonHeader, IonPage, IonTitle, IonLoading, IonToolbar } from "@ionic/react";
import styled, { css } from "styled-components";
import logo from "../assets/Logo.png";
import { Link, withRouter, BrowserRouter as Router, useHistory } from "react-router-dom";
import Page from "../components/Page";
import withNav from "../utils/hoc/withNav";
import ToastService from "../services/ToastService";
import Analytics, { TRACK_PAGE_CATEGORIES } from "../lib/anayltics";
import HistoryService from "../services/HistoryService";

const PageContainer = styled.div<any>`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: ${props => props.centered ? "center" : ""};
	padding: 0 1.5rem;
	flex-grow: 1;
	margin:${props => props.margin};
`;

const XookLogoContainer = styled.div`
	height: 19%;
	width: 100%;
	background: #ffcc00;
	padding: 0;
	display: flex;
`;

const Xook = styled.img`
	width: 16vh;
	height: 100%;
`;

const Title = styled.div`
	font-weight: 600;
	font-size: 25px;
	color: #e8e8e8;
	line-height: 26px;
	text-align: left;
`;

const Subtitle = styled.div`
	margin-top: 0.5rem;
	font-weight: 400;
	font-size: 18px;
	line-height: 16px;
	text-align: left;
	color: #b6b6b6;
`;

const Row = styled.div`
	display: flex;
	flex-direction: row;
	color: #fff;
	gap: 0 0.5rem;
`;

const CTA = styled.div`
	margin-top: 1.25rem;
	height: 39px;
	width: 121px;
	background: #f4c60a;
	color: #000;
	border-radius: 4px;
	font-weight: 600;
	font-size: 18px;
	display: flex;
	justify-content: center;
	align-items: center;
	text-transform: uppercase;
`;

const Separator = styled.div`
	margin-right: 15px;
`;

const KioskIdInput = styled.input``;


const Space = styled.div`
	margin: 2rem 0 0 0;
`;

const FadedContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem 0;
	height: 100%;
	width: 100%;
	background: #545454;
	padding: 2rem 0 0 1.5rem;
	height: 35%;
	margin-top: auto;
`;

const Message = styled.div`
	height: max-content;
	font-weight: 500;
	font-size: 4vh;
	width: min-content;
	line-height: 5vh;
	color: #e8e8e8;
	text-align: left;
	opacity: 0.1;
`;

const Text = styled.div<any>`
	color: #b6b6b6;
	margin:${props => props.margin};
	font-size: 14px;
	text-align: left;
`;

const Line = styled.div<any>`
	height: ${props => props.customHeight || "5px"};
	width: 46px;
	background: #ffcc00;
	opacity: ${props => props.faded ? "0.1" : "1"};
`;

const ErrorMsg = styled.span`
	color: #f57676;
	font-size: 12px;
	margin-top: 1.25rem;
	height: 12px;
	text-align: left;
`;

const Card = styled.div`
	position:relative;
	overflow:hidden;
	background:#4B4B4B;
	display:flex;
	flex-direction:column;
	align-items:flex-start;
	justify-content:space-between;
	padding:1rem;
	height:100px;
	width:150px;
	border-radius:6px;
	line-height:20px;
`;

const OverflowingText = styled.div`
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	width:100%;
	text-align:left;
`;

const Container = styled.div<any>`
	display:flex;
	flex-direction:row;
	flex-wrap:wrap;
	width:100%;
	gap:${props => props.gap};
	margin: ${props => props.margin};
`;

const HighLightedText = styled.span`
	color: #ffcc00 !important;
`;

const KIOSK_INPUT_PREFIX = "kioskId-char-";
const KIOSK_ID_LENGTH = 4;

const Kiosks: React.FC = (props: any) => {
	const [kioskId, setKioskId] = useState("");
	const [error, setError] = useState("");
	const { recentlyVisitedKiosks } = HistoryService.getRecentlyVisitedKiosks();
	let initialCustomInputRequired = recentlyVisitedKiosks.length ? false : true;
	const [customInput, setCustomInput] = useState(initialCustomInputRequired);
	const { navigate } = props;

	const handleChange = (event: any) => {
		setError("");

		let charIndex = event.target.id.charAt(event.target.id.length - 1),
			value = event.target.value.toUpperCase(),
			newKioskId = kioskId;

		if (value) {
			//newKioskId = newKioskId.slice(0, charIndex - 1) + value + newKioskId.slice(charIndex - 1);
			newKioskId = newKioskId.slice(0, charIndex - 1) + value + newKioskId.slice(charIndex, newKioskId.length);

			setKioskId(newKioskId);

			const nextInput = document.getElementById(`${KIOSK_INPUT_PREFIX}${parseInt(charIndex) + 1}`);

			if (nextInput) nextInput.focus();
		} else {
			newKioskId = newKioskId.slice(0, charIndex - 1) + newKioskId.slice(charIndex);
			setKioskId(newKioskId);
		}
	};

	const onKeyDown = (event: any) => {
		if (event.key === "Backspace") {
			const charIndex = event.target.id.charAt(event.target.id.length - 1);
			const prevInput = document.getElementById(`${KIOSK_INPUT_PREFIX}${parseInt(charIndex) - 1}`);
			if (!event.target.value) {
				if (prevInput) prevInput.focus();
			}
		}
	};

	const travelToKioskPage = () => {
		if (kioskId.length !== KIOSK_ID_LENGTH) {
			setError("Enter Valid Xook ID");
			return;
		}
		navigate.push(`/kiosk/${kioskId}`);
	};

	function onPageLoad() {
		Analytics.trackPage(TRACK_PAGE_CATEGORIES.PAGE_LOAD, "Select Kiosk");
	}

	function renderRecentlyVisitedKiosks(kiosks:any) {
		let renderData = [];
		for(const kiosk of kiosks) {
			const { kioskId, name } = kiosk;
			renderData.push(<Card onClick={() => navigate.push(`/kiosk/${kioskId}`)} >
				<OverflowingText>{name}</OverflowingText>
				<Line customHeight="3px" />
				Kiosk ID : {kioskId}
			</Card>)
		}
		return renderData;
	}

	useEffect(() => {
		onPageLoad();
	}, []);

	return (
		<Page padding={"0"}>
			<XookLogoContainer>
				<Xook src={logo} />
			</XookLogoContainer>

			{customInput ? (
				<PageContainer centered margin="32px 0" >
					<Title>Enter Xook ID</Title>
					<Space />
					<Subtitle>4 digit kiosk ID</Subtitle>
					<Space />
					<Row>
						<KioskIdInput
							onKeyDown={onKeyDown}
							maxLength={1}
							className="kiosk-input"
							onChange={handleChange}
							type="text"
							id={`${KIOSK_INPUT_PREFIX}1`}
						/>
						<KioskIdInput
							onKeyDown={onKeyDown}
							maxLength={1}
							className="kiosk-input"
							onChange={handleChange}
							type="text"
							id={`${KIOSK_INPUT_PREFIX}2`}
						/>
						<KioskIdInput
							onKeyDown={onKeyDown}
							maxLength={1}
							className="kiosk-input"
							onChange={handleChange}
							type="text"
							id={`${KIOSK_INPUT_PREFIX}3`}
						/>
						<KioskIdInput
							onKeyDown={onKeyDown}
							maxLength={1}
							className="kiosk-input"
							onChange={handleChange}
							type="text"
							id={`${KIOSK_INPUT_PREFIX}4`}
						/>
					</Row>
					<ErrorMsg>{error}</ErrorMsg>
					<CTA onClick={travelToKioskPage}>CONFIRM</CTA>
				</PageContainer>
			) : (
				<PageContainer centered margin="32px 0" >
					<Title>Recently Opened Kiosks</Title>

					<Container gap="1rem" margin="2rem 0 0 0" >
						{renderRecentlyVisitedKiosks(recentlyVisitedKiosks)}
					</Container>
					
					<Text margin="8vh 0 0 0" > 
						Not the above listed one? <HighLightedText onClick={() => setCustomInput(true)} >Enter Kiosk ID</HighLightedText>
					</Text>

				</PageContainer>
			)}

			<FadedContainer>
				<Message>RESTO FROM THE FUTURE.</Message>
				<Line faded />
			</FadedContainer>
		</Page>
	);
};

export default withNav(Kiosks);
